// src/hooks/useMetrics.js
import { useState } from "react";
import { useAuth } from "./";
import { getFinanceDashboardApi } from "../api/metrics";


export function useMetrics() {
  const { auth } = useAuth();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [financeDashboard, setFinanceDashboard] = useState(null);

  const getFinanceDashboard = async (params) => {
    try {
      setLoading(true);
      setError(null);
      const data = await getFinanceDashboardApi(auth.token, params);
      setFinanceDashboard(data);
      setLoading(false);
      return data;
    } catch (err) {
      setLoading(false);
      setError(err);
      throw err;
    }
  };

  return {
    loading,
    error,
    financeDashboard,
    getFinanceDashboard,
  };
}
